import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A year of 750words.com - with shiny graphs",
  "description": "",
  "published": "2012-05-18T00:00:00.000Z",
  "redirect_from": ["/blog/a-year-of-750words-com-with-shiny-graphs/swizec/4378"],
  "categories": "750words, Arts, Facebook, Google, Uncategorized, Writers Resources, Writing, Writing Exercises",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`384 days ago I wrote my first morning pages on `}<a parentName="p" {...{
        "href": "http://750words.com"
      }}>{`750words.com`}</a></p>
    <p>{`Since then I have:`}</p>
    <ul>
      <li parentName="ul">{`written 315,026 words (or about 7 novels)`}</li>
      <li parentName="ul">{`spent 12 minutes on every day's words`}</li>
      <li parentName="ul">{`written an average of 820 words a day`}</li>
      <li parentName="ul">{`mentioned `}<strong parentName="li">{`sex`}</strong>{` 408 times`}</li>
      <li parentName="ul">{`mentioned `}<strong parentName="li">{`tea`}</strong>{` 503 times`}</li>
      <li parentName="ul">{`used `}<strong parentName="li">{`1402`}</strong>{` curse words`}</li>
    </ul>
    <p>{`Writing the words every day is `}<em parentName="p">{`awesome`}</em>{`. It's like morning exercise but for your brain - very awesome for waking up and forcing the brain to get up to speed and ready to face the day.`}</p>
    <p>{`And it's very liberating too. Since you're not writing for anybody, not even for yourself (I often mash out the whole thing with my eyes closed) you can say literally anything about anyone or anything. Sometimes things come out you didn't even know you were thinking!`}</p>
    <p>{`Awesomer still is the fact you now have a deep dataset about yourself. Your mood, your thoughts, going back ... very far. Seeing your feelings in such plasticity is quite interesting.`}</p>
    <p>{`Here's a graph of my mood for the past 384 days.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://scriblinmind.wordpress.com/2012/05/16/how-to-become-interesting-with-graphs/"
        }}>{`How To Become Interesting (with Graphs)`}</a>{` (scriblinmind.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://writeofinitiation.wordpress.com/2012/05/11/were-going-to-need-a-bigger-graph/"
        }}>{`We're Going To Need A Bigger Graph`}</a>{` (writeofinitiation.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://householdopera.typepad.com/household_opera/2010/06/in-praise-of-750-words.html"
        }}>{`In praise of 750 Words`}</a>{` (householdopera.typepad.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.buzzfeed.com/katienotopoulos/can-a-graph-of-a-news-articles-words-tell-you-mor"
        }}>{`Can A Graph Of A News Article's Words Tell You More Than Reading It?`}</a>{` (buzzfeed.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=38799454-438e-4f6f-9b23-117a086ca22a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      